import { createTransform, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { createWhitelistFilter } from 'redux-persist-transform-filter';
import IStore from './store.interface';
import config from '../config/config';
import { TabsConfig } from '../models';
import { INotificationsListState, TABLE_STATE_DEFAULT_STATE } from '../state/reducers/notificationsList';
import produce from 'immer';
import { Locations } from '../models/locations';

const _persistTransformsConfig = {
    userId: null,
    systemId: null,
    environmentId: null
};

export const setPersistTransformsConfig = (config: { userId: number; systemId: string; environmentId: string }) =>
    Object.assign(_persistTransformsConfig, config);

export const persistConfig = {
    key: `root-${config.version}`,
    storage,
    whitelist: ['notifications', 'edit', 'common', 'router'],
    stateReconciler: autoMergeLevel2,
    transforms: [
        createWhitelistFilter('router', ['location']),
        createWhitelistFilter('notifications', ['activeTab', 'drawer', 'searchTerm', 'tableStates', 'allNotificationsView']),
        createWhitelistFilter('edit', ['currentStep', 'notification', 'dirty', 'templateHistory']),
        createWhitelistFilter('common', ['images', 'dynamicAttributes', 'forcedAnalyticsSource']),
        createTransform(
            null,
            (state: $TSFixMe) => {
                if (!state) {
                    return null;
                }
                return produce(state, (updatedState: INotificationsListState) => {
                    const { activeTab, tableStates } = updatedState;
                    updatedState.tableStates = { ...TABLE_STATE_DEFAULT_STATE };
                    const tableKey = TabsConfig[activeTab]?.tableKey;

                    if (updatedState.tableStates?.[tableKey]) {
                        updatedState.tableStates[tableKey] = {
                            ...tableStates[tableKey],
                            animateIds: new Map()
                        };
                    }
                });
            },
            { whitelist: ['notifications'] }
        ),
        createTransform<$TSFixMe, $TSFixMe, IStore>(
            state => ({ [`${_persistTransformsConfig.systemId}_${_persistTransformsConfig.environmentId}`]: state }),
            (state: $TSFixMe) => state?.[`${_persistTransformsConfig.systemId}_${_persistTransformsConfig.environmentId}`],
            { whitelist: ['edit', 'notifications'] }
        ),
        createTransform<$TSFixMe, $TSFixMe, IStore>(
            // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
            state => ({ [_persistTransformsConfig.userId]: state }),
            // @ts-expect-error ts-migrate(2538) FIXME: Type 'null' cannot be used as an index type.
            state => state?.[_persistTransformsConfig.userId],
            { whitelist: ['common'] }
        ),
        createTransform<$TSFixMe, $TSFixMe, IStore>(
            state => {
                if (location.pathname === Locations.Edit) {
                    return state;
                }
                return null;
            },
            state => {
                if (location.pathname === Locations.Edit) {
                    return state;
                }
                return null;
            },
            { whitelist: ['edit'] }
        )
    ]
};

const createPersistReducer = (rootReducer: $TSFixMe) => {
    return persistReducer<IStore>(persistConfig, rootReducer);
};

export default createPersistReducer;
